import { createFileRoute } from "@tanstack/react-router";
import { RulesPage } from "@/features/automation/rules-page";
import { apiQuery } from "@/lib/api/hooks";

export const Route = createFileRoute("/_app/automation/")({
  // prefetch (also on hover); errors are shown in-page with a retry
  loader: ({ context }) => context.queryClient.ensureQueryData(apiQuery("rules", {})).catch(() => undefined),
  head: () => ({ meta: [{ title: "Rules · Malfak" }] }),
  component: RulesPage,
});
